<template>
  <div class="d-flex">
    <v-container>

      <v-col cols="12" sm="10" class="pb-0 mt-10">
        <div class="text-left">NOM PROJET</div>
        <div class="text-left font-weight-bold">{{ projet.nom_projet }}</div>
      </v-col>

      <v-row class="mt-2" align-self="end" align="center" no-gutters>
        <v-col cols="4" sm="3" class="pl-3 mt-1">
          <div class="text-left">DATE DU PROJET</div>
          <div class="text-left font-weight-bold">{{ formatDate }}</div>
        </v-col>
        <v-col cols="4" sm="4" class="pl-10 mt-1">
          <div class="text-left">CREATEUR</div>
          <div class="text-left font-weight-bold">{{ createur }}</div>
        </v-col>
      </v-row>

      <v-row class="mt-4" no-gutters>
        <v-col cols="4" class="pl-3" align="left">
          <div class="text-left">PROJET BLOC FORE</div>
          <div class="text-left font-weight-bold">{{ projet.bloc_fore ? "OUI" : "NON" }}</div>
        </v-col>
      </v-row>

      <v-row v-if="projet.bloc_fore">
        <v-col cols="12" class="pl-3 pb-0">
          <v-tabs v-model="activeTab" background-color="#0B87BA" dark>
            <v-tab>Projet</v-tab>
            <v-tab>Cahier des charges</v-tab>
            <v-tab>Calcul du coût</v-tab>
            <v-tab>Calcul prix de vente</v-tab>
            <v-tab>Offre commerciale</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <!-------------------------------- Tab Projet -------------------------------->
      <div v-show="!projet.bloc_fore || activeTab === 0">

        <AddContacts :personnes="projet.personnes" mode="visualisation" />

        <ProjetBlocDescription :projet="projet" tab="Projet" mode="visualisation" />

        <ProjetEtapes v-if="projet.bloc_fore" :projet="projet" mode="visualisation" />

        <!-------------------------------- Historique des commentaires -------------------------------->
        <div v-if="projet.commentaires && projet.commentaires.length > 0">
          <v-col cols="12" sm="10" class="pb-0 mt-10">
            <v-toolbar color="#0B87BA" flat dense>
              <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
                HISTORIQUE DES COMMENTAIRES
              </v-col>
            </v-toolbar>
          </v-col>
          <v-col cols="12" sm="10" class="text-left">
            <div v-for="commentaire in projet.commentaires.slice().reverse()" :key="commentaire.createdAt">
              <div class="date-letter text-uppercase">
                {{ commentaire.User.nom }} - {{ commentaire.createdAt ? $moment(commentaire.createdAt).format("LL") : "" }}
              </div>
              <div class="font-italic text-h6" style="overflow-wrap: break-word;">"{{ commentaire.commentaire }}"</div>
            </div>
          </v-col>
        </div>

        <AddRappels :rappels="projet.rappels" mode="visualisation" />

        <AddDocuments :project="projet" mode="visualisation" />

        <!-------------------------------- Etat du projet -------------------------------->
        <v-col cols="12" sm="10" class="pb-0 mt-10">
          <v-toolbar color="#0B87BA" flat dense>
            <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
              ETAT DU PROJET
            </v-col>
          </v-toolbar>
        </v-col>
        <v-col cols="12" sm="10" class="pb-0">
          <div class="text-left mt-5">PROJET OBTENU</div>
          <div v-if="projet.projet_obtenu == null" class="text-left font-weight-bold">Non renseigné.</div>
          <div v-else class="text-left font-weight-bold">{{ projet.projet_obtenu ? 'OUI' : 'NON' }}</div>
        </v-col>
        <v-col v-if="projet.projet_obtenu !== null" cols="12" sm="10" class="alignement_input">
          <div class="text-left">COMMENTAIRE</div>
          <div class="text-left font-weight-bold">{{ projet.commentaire_projet_obtenu }}</div>
        </v-col>

      </div>
      <!-------------------------------- Tab Cahier des charges -------------------------------->
      <div v-show="projet.bloc_fore && activeTab === 1">

        <ProjetBlocDescription :projet="projet" tab="Cahier_des_charges" mode="visualisation" />

        <AddArticles :retour_a_articles="projet.projet_a_articles" mode="visualisation" :blocFore="true" />

        <div class="mt-3">
          <div class="image-container">
            <img
              :src="projet.document && projet.document.chemin ? `${http}${projet.document.chemin}` : imageUrl"
              class="image"
              :style="{ transform: 'scale(' + zoomLevel + ')' }"
              alt="Plan du bloc"
            />
          </div>
          <div class="mt-3 mb-3">
            <v-btn @click="zoomOut">Zoom -</v-btn>
            <v-btn @click="zoomIn">Zoom +</v-btn>
          </div>
        </div>

        <v-toolbar color="#0B87BA" flat dense>
          <v-col cols="12" lg="12" xl="12" class="pa-0 font_color text-left">
            IMPLANTATIONS ET DIMENSIONS - indiquez les dimensions hors-tout (cartouches inclues)
          </v-col>
        </v-toolbar>
        <v-row>
          <v-col cols="8" sm="8" class="mt-5 text-left">
            <img src="@/assets/dimensions.png" style="width:70%; height:70%" alt="" />
          </v-col>
          <v-col cols="4" sm="4" class="mt-5 text-left">
            <div class="text-left">Longueur</div>
            <div class="text-left font-weight-bold">{{ projet.longueur }}</div>
            <div class="mt-3 text-left">Largeur</div>
            <div class="text-left font-weight-bold">{{ projet.largeur }}</div>
            <div class="mt-3 text-left">Hauteur</div>
            <div class="text-left font-weight-bold">{{ projet.hauteur }}</div>
          </v-col>
        </v-row>

        <v-container>
          <v-row class="table-fields">
            <v-col cols="12" sm="12" class="pb-0">
              <div class="text-left"><b>FACE 6 (Face de fixation du bloc) :</b></div>
              <div class="text-left font-weight-bold">{{ projet.face_6 }}</div>
            </v-col>
          </v-row>
          <v-row class="table-header">
            <v-col v-for="(column, index) in columns" :key="index" cols="2">
              <h2>{{ column }}</h2>
            </v-col>
          </v-row>
          <div v-if="projet.rows && projet.rows.length > 0">
            <v-row v-for="(row, rowIndex) in projet.rows" :key="rowIndex" class="table-row">
              <v-col v-for="(column, index) in columns" :key="index" cols="2" class="table-cell" style="height: auto;">
                <div class="text-left font-weight-bold" style="word-wrap: break-word;">{{ row['face' + (index + 1)] }}</div>
              </v-col>
            </v-row>
          </div>
        </v-container>

      </div>

      <div v-show="projet.bloc_fore && activeTab >= 2">
        <v-alert type="info" class="mt-6 text-left">Cette section est en cours de développement.</v-alert>
      </div>

      <v-col cols="12" sm="10" class="alignement_input">
        <router-link :to="{ name: 'client', params: { id_entreprise: $route.params.id_entreprise } }" style="text-decoration: none;">
          <v-btn @click="$store.state.currentTab = 1" class="btnBold" color="#FF9900" dark rounded>
            RETOUR
          </v-btn>
        </router-link>
      </v-col>

    </v-container>
  </div>
</template>

<script>
import ProjetBlocDescription from "@/components/Clients/ProjetBlocDescription";
import ProjetEtapes from "@/components/Clients/ProjetEtapes";
import AddArticles from "@/components/Clients/AddArticles";
import AddContacts from "@/components/Clients/AddContacts";
import AddRappels from "@/components/Clients/AddRappels";
import AddDocuments from "@/components/Clients/AddDocuments";
import moment from "moment";

export default {
  props: {
    projet: { type: Object, required: true },
    utilisateurs: { type: Array, required: true },
  },
  components: {
    ProjetBlocDescription,
    ProjetEtapes,
    AddContacts,
    AddArticles,
    AddRappels,
    AddDocuments,
  },
  data() {
    return {
      activeTab: 0,
      http: process.env.VUE_APP_BASE_URL,
      zoomLevel: 1,
      columns: ['Face 1', 'Face 2', 'Face 3', 'Face 4', 'Face 5', 'Face 6'],
      imageUrl: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
    };
  },
  computed: {
    formatDate() {
      return this.projet.date_projet ? moment(this.projet.date_projet).format("L") : "";
    },
    createur() {
      const found = this.utilisateurs.find(u => u.id_utilisateur === this.projet.id_utilisateur);
      return found ? found.nom : "non défini";
    },
  },
  methods: {
    zoomIn() {
      this.zoomLevel = Math.min(3, this.zoomLevel + 0.1);
    },
    zoomOut() {
      this.zoomLevel = Math.max(1, this.zoomLevel - 0.1);
    },
  },
};
</script>

<style scoped>
.font_color {
  font-weight: bold;
  color: #ffffff;
}
.btnBold {
  font-weight: bold;
}
.date-letter {
  font-size: 15px !important;
}
.image-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.image {
  display: block;
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
}
.table-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}
.table-row {
  border-bottom: 1px solid #ddd;
}
.table-fields {
  border: 1px solid #ddd;
}
.table-cell {
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
</style>
